<h2 mat-dialog-title>{{title}}</h2>

<div mat-dialog-content>
    <p>{{message}}</p>
</div>

<div mat-dialog-actions>
    <button class="btn btn-primary" (click)="close()">Close</button>
</div>